const FILTER_TO_RENDER = {
  'relevanceFields.exclusiveBrand': 'Marca Própria',
  'relevanceFields.exclusiveMarkeplace': 'Exclusivo Leroy Merlin',
  'relevanceFields.hasStock': 'Em estoque',
  'relevanceFields.novelty': 'Novidades',
  'boitataFacets.sellers': 'Vendido Por',
  'boitataFacets.free-shipping': 'Frete Grátis',
  'boitataFacets.express-shipping': 'Entrega Rápida',
  'boitataFacets.black-friday': 'Black Friday',
  'offer.enabled': 'Somente Ofertas',
  'price.promotional': 'Preço'
}

export type MappedAttributes = keyof typeof FILTER_TO_RENDER

export const filterToRender = (attribute: MappedAttributes) => {
  const prefix = 'attributes.'

  if (attribute.startsWith(prefix)) {
    return attribute.slice(prefix.length)
  }

  return FILTER_TO_RENDER[attribute]
}
